import moment from "moment";
import {AsiaJerusalemTZ} from "../../../event/DaysMapper";
import {DEFAULT_DELIVERY_ARRIVING_TIME_RANGE} from "../../MarketplaceUtils.jsx";
import {isProductHasShippingProvider} from "../../../admin/upload/utils.js";
import {TWO_DAY_RANGE_HOURS} from "../../OrderFormTimePanel/consts";

export const calculateUntilTime = (dtstart, untilTime, untilDate, deliveryArrivingTimeRange) => {
    const isTwoDayRange = deliveryArrivingTimeRange >= TWO_DAY_RANGE_HOURS;
    
    if (untilTime && untilDate) {
        const untilDateFormatted = moment(untilDate).format("DD/MM/YYYY");
        const untilTimeFormatted = moment(untilTime).format("HH:mm");
        return moment(`${untilDateFormatted} ${untilTimeFormatted}`, "DD/MM/YYYY HH:mm").tz(AsiaJerusalemTZ).valueOf();
    } else if (untilTime) {
        let calculatedDate = moment(dtstart).add(deliveryArrivingTimeRange, "hours");
        if (isTwoDayRange) {
            // For two-day range: subtract 1 day and set to 18:00 (ignore provided untilTime)
            calculatedDate = calculatedDate.subtract(1, "day").set({hour: 18, minute: 0, second: 0, millisecond: 0});
            return calculatedDate.tz(AsiaJerusalemTZ).valueOf();
        } else {
            const untilDateFormatted = moment(calculatedDate).format("DD/MM/YYYY");
            const untilTimeFormatted = moment(untilTime).format("HH:mm");
            return moment(`${untilDateFormatted} ${untilTimeFormatted}`, "DD/MM/YYYY HH:mm").tz(AsiaJerusalemTZ).valueOf();
        }
    } else {
        let calculatedUntil = moment(dtstart).add(deliveryArrivingTimeRange, "hours");
        if (isTwoDayRange) {
            // For two-day range: subtract 1 day and set to 18:00
            calculatedUntil = calculatedUntil.subtract(1, "day").set({hour: 18, minute: 0, second: 0, millisecond: 0});
        }
        return calculatedUntil.tz(AsiaJerusalemTZ).valueOf();
    }
};

export const getValuesForCreateEvent = (
    formValues,
    deliveryOptions,
    serviceId,
    paymentType,
    offeredPrice,
    company,
    deliveryPrice,
    coupon,
    couponDiscountAmount,
    creditCard,
    upgradeOptionsPrice,
    planBudgetOrder,
    providerDetails
) => {
    const dateFormatted = moment(formValues?.date).format("DD/MM/YYYY");
    const timeFormatted = moment(formValues?.time).format("HH:mm");
    const dtstart = moment(`${dateFormatted} ${timeFormatted}`, "DD/MM/YYYY HH:mm").tz(AsiaJerusalemTZ).valueOf();
    const deliveryArrivingTimeRange = deliveryOptions?.arrivingTimeRange ?? DEFAULT_DELIVERY_ARRIVING_TIME_RANGE;
    
    const until = calculateUntilTime(
        dtstart,
        formValues?.untilTime,
        formValues?.untilDate,
        deliveryArrivingTimeRange
    );
    const modularProducts = formValues?.modularProducts?.filter(product => product?.amount > 0);

    const valuesForCreateEvent = {
        ...formValues,
        serviceId,
        dtstart,
        until,
        paymentType,
        offeredPrice,
        address: formValues?.chosenAddress || company?.address,
        branches: company?.branches?.[0] || null,
        companyPhone: company?.phone,
        deliveryPrice,
        coupon: coupon?.valid ? coupon : null,
        couponDiscountAmount: coupon?.valid ? couponDiscountAmount : null,
        creditCard,
        modularProducts,
        upgradeOptionsPrice,
        deliveryArrivingTimeRange,
        companyDiscountPercentage: company?.ordersDiscount
    };

    if (planBudgetOrder) {
        valuesForCreateEvent.planBudgetOrder = {
            planId: planBudgetOrder?.planId,
            occasionCategoryId: planBudgetOrder?.occasionCategoryId,
            occasionId: planBudgetOrder?.occasionId
        };
    }

    if (providerDetails?.isVoucherProvider) {
        if (formValues?.timeOption?.type === "CUSTOM_DATE") {
            const {date, time} = formValues.timeOption;
            valuesForCreateEvent.dtstart = moment(
                `${date.format("YYYY-MM-DD")} ${time.format("HH:mm")}`,
                "YYYY-MM-DD HH:mm"
            )
                .toDate()
                .getTime();
        }

        valuesForCreateEvent.until = valuesForCreateEvent?.dtstart;
    }
    return valuesForCreateEvent;
};
